import { Field, Text } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import { TYPOGRAPHY_HEADING1_BOLD } from "@/theme/topshop/typography/typography-constants";
import styles from "./faq-header.module.css";

export type FaqHeaderProps = ComponentProps & {
  fields: {
    data: { contextItem: { title: Field<string> } };
  };
};

const FaqHeader = ({ fields: { data } }: FaqHeaderProps) => {
  const { contextItem } = data;
  return (
    <div className={styles.faqHeaderContainer}>
      <Text
        tag="h1"
        field={contextItem.title}
        className={TYPOGRAPHY_HEADING1_BOLD}
      />
    </div>
  );
};

export default FaqHeader;
